<template>
<div id="reservations">
    <vue-headful title="Reservations" />
    <v-container class="pa-0 ma-0" fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <!-- reservations FILTERS -->
        <v-row no-gutters>
            <!-- status filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Status</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="status" :items="status_items" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="getItems()" hide-details />
                </v-card>
            </v-col>
            <!--./ status filter-->

            <!-- date filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Create date</div>
                    <div class="d-flex">
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo :clearable="$vuetify.breakpoint.smAndUp" readonly placeholder="From ..." slot="activator" v-model="comp_timestamp_after" @input="getItems()" hide-details />
                            </template>
                            <v-date-picker v-model="timestamp_after" no-title @input="getItems()" width="265">
                                <v-spacer />
                                <v-btn text dark color="red" @click="timestamp_after = null;">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-0">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo :clearable="$vuetify.breakpoint.smAndUp" readonly slot="activator" placeholder="Until ..." v-model="comp_timestamp_before" @input="getItems()" hide-details />
                            </template>
                            <v-date-picker v-model="timestamp_before" :min="timestamp_after" no-title @input="getItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text color="red" dark @click="timestamp_before = null;">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </v-card>
            </v-col>
            <!--./ date filter-->

            <!-- check in filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold">Check in</div>
                    <div class="d-flex">
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :clearable="$vuetify.breakpoint.smAndUp" slot="activator" placeholder="After ..." v-model="comp_check_in_after" @input="getItems()" hide-details />
                            </template>
                            <v-date-picker v-model="check_in_after" no-title @input="getItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text dark color="red" @click="check_in_after = null;">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-0">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :clearable="$vuetify.breakpoint.smAndUp" slot="activator" placeholder="Before ..." v-model="comp_check_in_before" @input="getItems()" hide-details />
                            </template>
                            <v-date-picker v-model="check_in_before" :min="check_in_after" no-title @input="getItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text color="red" @click="check_in_before = null;">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </v-card>
            </v-col>
            <!--./ check in filter-->

            <!-- check out filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold">Check out</div>
                    <div class="d-flex">
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :clearable="$vuetify.breakpoint.smAndUp" slot="activator" placeholder="After ..." v-model="comp_check_out_after" @input="getItems()" hide-details />
                            </template>
                            <v-date-picker v-model="check_out_after" no-title @input="getItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text dark color="red" @click="check_out_after = null;">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-0">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :clearable="$vuetify.breakpoint.smAndUp" slot="activator" placeholder="Before..." v-model="comp_check_out_before" @input="getItems()" hide-details />
                            </template>
                            <v-date-picker v-model="check_out_before" :min="check_out_after" no-title @input="getItems()" width="265">
                                <v-spacer></v-spacer>
                                <v-btn text dark color="red" @click="check_out_before = null;">Clear date</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </v-card>
            </v-col>
            <!--./ check out filter-->

        </v-row>
        <!-- ./ reservations FILTERS -->

        <!-- SEARCH -->
        <div class="im-search py-1">

            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon medium v-if="$vuetify.breakpoint.smAndDown" class="px-1" @click="dialog_mobile_sort = true">swap_vert
                </v-icon>
                <im-download v-if="$vuetify.breakpoint.mdAndUp" slot="activator" type="xls" name="reservations.xls" :fields="item_headers_reservations" ref="csv_reservation">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" size="32" style="transform: rotate(180deg);" v-if="!download_loading_reservation" @click="getDownloadRervations()">publish</v-icon>
                        </template>
                        <span>Download csv</span>
                    </v-tooltip>
                    <v-progress-circular v-if="download_loading_reservation" indeterminate color="primary"></v-progress-circular>
                </im-download>
            </div>

            <div class="mx-1 py-2 fields d-flex align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" small rounded depressed class="detail mx-1" :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize">{{field.text}}</span>
                </v-btn>
            </div>

        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="mx-1">
            <!-- <v-data-iterator :items="items" :pagination.sync="pagination" :total-items="total" :rows-per-page-items="rppi"> -->
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template slot="item" slot-scope="props">
                    <im-reservation-item :item="props.item" @click.native="seeReservation(props.item)" />
                </template>

                <template slot="no-data">
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </v-container>

    <!-- dialog reservation -->
    <v-dialog v-model="dialog_reservation" width="920" max-height="600" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card class="modal-reservation" flat>

            <v-card-title class="headline p-2">
                Booking Details
                <v-spacer />
                <v-btn icon left @click="dialog_reservation=false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <im-reservation-modal :item_id="reservation_id" id="print-area" :show_comments="show_comments" ref="reservation" @all_comments="numberComments($event)" />
            </v-card-text>
            <v-card-actions v-if="$vuetify.breakpoint.smAndUp">
                <v-btn v-if="comments > 0" text outlined color="primary" @click="show_comments= !show_comments" class="mx-1">
                    <span>{{ comments }} Comments </span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-menu open-on-hover top offset-y v-if="change_status_items">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="mx-1" text outlined color="primary">Change status</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in change_status_items" :key="index" @click="confirmChangeStatus(item.value)">
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu open-on-hover top offset-y class="mx-1">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="mx-1" text outlined color="primary">Send email</v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="sendEmail(reservation_id, 'send_to_client')">
                            <v-list-item-title>Client</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="sendEmail(reservation_id, 'send_to_hotel')">
                            <v-list-item-title>Hotel</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn text outlined color="primary" @click="printReservation('print-area')" class="mx-1">Print</v-btn>
            </v-card-actions>

            <v-speed-dial v-else v-model="fab" bottom right transition="slide-y-reverse-transition">
                <template v-slot:activator>
                    <v-btn v-model="fab" color="primary" dark fab>
                        <v-icon v-if="fab">more_vert</v-icon>
                        <v-icon v-else>close</v-icon>
                    </v-btn>
                </template>
                <v-btn dark small color="blue" v-if="comments > 0" @click="show_comments= !show_comments">
                    <span>Comment</span>
                    <v-icon class="pl-1" size="14">comment</v-icon>
                </v-btn>
                <v-btn dark small color="indigo" @click="dialog_send_mail = true">
                    <span>Send</span>
                    <v-icon class="pl-1" size="14">mail_outline</v-icon>
                </v-btn>
                <v-btn v-if="change_status_items" dark small color="green" @click="dialog_change_status = true">
                    <span>Status</span>
                    <v-icon class="pl-1" size="14">attach_money</v-icon>
                </v-btn>

            </v-speed-dial>
        </v-card>
    </v-dialog>
    <!-- ./ dialog reservation -->

    <!-- dialog send mail -->
    <v-dialog v-model="dialog_send_mail" max-width="300px">
        <v-card>
            <v-card-text class="important">
                You want to send mail to:
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="sendEmail(reservation_id, 'send_to_client')">
                    Client
                </v-btn>
                <v-btn text @click="sendEmail(reservation_id, 'send_to_hotel')">
                    Hotel
                </v-btn>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_send_mail = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog send mail -->

    <!-- dialog send mail -->
    <v-dialog v-model="dialog_change_status" max-width="300px">
        <v-card>
            <v-card-text class="important">
                You want to change status in:
            </v-card-text>
            <v-card-text class="regular">
                <v-select :items="change_status_items" item-text="text" label="Select status" item-value="value" @input="confirmChangeStatus(item)"></v-select>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_change_status = false, revertStatus()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog send mail -->

    <!-- dialog reservation status -->
    <v-dialog v-model="dialog_reservation_status" max-width="400px">
        <v-card>
            <v-card-text>
                <div class="">
                    Are you sure you want to switch the status of reservation <b class="text--primary">{{reservation.id}}</b>
                    ?
                </div>
                <div class="">
                    <v-text-field flat v-model="comment" clearable placeholder="Your reason to change the status" hide-details></v-text-field>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="revertStatus">
                    No
                </v-btn>
                <v-btn :disabled="!comment" :loading="status_loading" color="primary" @click="changeStatus()">
                    Yes
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog reservation status -->

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_mobile_sort = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->

</div>
</template>

<script>
import Download from '../components/utils/Download.vue';
import IMTableHeader from '../components/utils/IMTableHeader.vue';
import IMSortField from "../components/utils/IMSortField.vue";
import IMReservationItem from '../components/items/ReservationCard.vue';
import IMReservationModal from '../components/items/ReservationModal.vue';


export default {
    name: `reservations`,

    components: {
        'im-download': Download,
        'im-table-header': IMTableHeader,
        "im-sort-filed": IMSortField,
        'im-reservation-item': IMReservationItem,
        'im-reservation-modal': IMReservationModal
    },

    data() {
        return {
            // comments
            comments: 0,
            show_comments: false,
            status_loading: false,

            comment: null,
            fab: false,
            dialog_change_status: false,
            dialog_reservation: false,
            dialog_reservation_status: false,
            dialog_mobile_sort: false,
            dialog_send_mail: false,

            reservation_id: null,
            reservation: {
                //status: null,
                agency: {
                    name: null,
                    commission: null
                },
                client_contact: {
                    name: null,
                    email: null,
                    phone: null
                },
                hotel_contact: {
                    contact_email: null,
                    email: null,
                    phone: null
                },

            },

            // date filters
            timestamp_after: null,
            timestamp_before: null,
            check_in_after: null,
            check_in_before: null,
            check_out_after: null,
            check_out_before: null,

            // search
            search: null,
            search_fields: [
                {
                    text: 'Id',
                    value: 'id',
                    selected: true
                }, {
                    text: 'Hotel Name',
                    value: 'hotel_name',
                    selected: true
                }, {
                    text: 'Client Name',
                    value: 'client_contact.name',
                    selected: true
                }, {
                    text: 'Client Email',
                    value: 'client_contact.email',
                    selected: false
                }, {
                    text: 'Client Phone',
                    value: 'client_contact.phone',
                    selected: false
                }
            ],
            search_timeout: 300,

            // status filter
            status: null,
            change_status_items: null,
            status_items: [
                {
                    text: "Booked",
                    value: "booked"
                }, {
                    text: "Canceled",
                    value: "canceled"
                }, {
                    text: "No Show",
                    value: "no-show"
                }
            ],
            // imemento table
            im_header: [
                {
                    text: "Booking Code",
                    width: "10%",
                    sortable: false,
                    sort_order: "",
                    sort_dir: null,
                }, {
                    text: "Hotel",
                    width: "26%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "Booking Date",
                    width: "10%",
                    sort_order: "timestamp",
                    sortable: true,
                    sort_dir: 'desc',
                }, {
                    text: "CI",
                    width: "4%",
                    sort_order: "check_in",
                    align: "right",
                    sortable: true,
                    sort_dir: null,
                }, {
                    text: "CO",
                    width: "4%",
                    sort_order: "check_out",
                    sortable: true,
                    sort_dir: null,
                }, {
                    text: "Price",
                    width: "14%",
                    align: "right",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "Client",
                    width: "22%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: "Agency",
                    width: "10%",
                    sortable: false,
                    sort_dir: null,
                },
            ],

            // table items
            items: [],
            download_items: [],
            download_loading: false,

            // table attributes
            loading: null,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

            // download csv
            download_loading_reservation: false,
            item_headers_reservations: {
                'Booking Code': 'id',
                'Status': 'status',
                'Nume hotel': 'hotel_contact.name',
                'Localitate hotel': 'hotel_contact.city',
                'Regiune hotel': 'hotel_contact.region',
                'Creat': 'timestamp',
                'Check-In': 'check_in',
                'Check-Out': 'check_out',
                'Nopti': 'nights',
                'Camere': 'rooms',
                'Camere-Nopti': 'rooms_nights',
                'Pret total': 'pricing.total',
                'Pret final': 'pricing.after_tax',
                'Moneda Hotel': 'pricing.currency',
                'Total EUR': 'pricing.total_eur',
                'Nume agentie': 'agency.name',
                'Comision agentie': 'agency.commissioning.agency.commission_percentage',
                'Comisionul agentiei': 'agency.commissioning.agency.commission_value',
                'Nume client': 'client_contact.last_name',
                'Prenume client': 'client_contact.first_name',
                'Email client ': 'client_contact.contact.email',
                'Client telefon': 'client_contact.contact.phone',
                'Hotel Contact Email': 'hotel_contact.contact_email',
                'Hotel Email': 'hotel_contact.email',
                'Hotel telefon': 'hotel_contact.phone'
            },
        };
    },

    computed: {
        comp_timestamp_after: {
            get: function () {
                return this.formatDate(this.timestamp_after);
            },
            set: function (val) {
                return this.timestamp_after = val;
            }

        },
        comp_timestamp_before: {
            get: function () {
                return this.formatDate(this.timestamp_before);
            },
            set: function (val) {
                return this.timestamp_before = val;
            }

        },
        comp_check_in_after: {
            get() {
                return this.formatDate(this.check_in_after)
            },
            set(val) {
                this.check_in_after = val;
            }
        },
        comp_check_in_before: {
            get() {
                return this.formatDate(this.check_in_before)
            },
            set(val) {
                this.check_in_before = val;
            }
        },
        comp_check_out_after: {
            get() {
                return this.formatDate(this.check_out_after)
            },
            set(val) {
                this.check_out_after = val;
            }

        },
        comp_check_out_before: {
            get: function () {
                return this.formatDate(this.check_out_before);
            },
            set: function (val) {
                return this.check_out_before = val;
            }

        },

        rppt() {
            return this.$translate.text("app_rppt");
        }
    },

    created() {
        this.getItems();
    },

    watch: {
        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 200);
            }
        },

    },

    methods: {

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            } else {
                orders = ['timestamp']
                dirs = ['desc']
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/reservations";

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp,
                    // operational fields
                    status: this.status,
                    timestamp_after: this.timestamp_after,
                    timestamp_before: this.timestamp_before,
                    check_in_after: this.check_in_after,
                    check_in_before: this.check_in_before,
                    check_out_after: this.check_out_after,
                    check_out_before: this.check_out_before
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getNewStatusItems(check_in, check_out, status) {

            this.change_status_items = null;

            let invoice_day = this.$moment(check_out * 1000)
                .add(1, 'month')
                .date(15);
            let today = this.$moment();

            if(today.isBefore(check_in * 1000) && status === 'booked') {
                this.change_status_items = [{
                        text: "Booked",
                        value: "booked"
                    },
                    {
                        text: "Canceled",
                        value: "canceled"
                    }];
                return
            }

            if((today.isAfter(check_in * 1000) && today.isBefore(invoice_day)) && status === 'booked') {
                this.change_status_items = [{
                        text: "Booked",
                        value: "booked"
                    },
                    {
                        text: "No Show",
                        value: "no-show"
                    }];
                return
            }

            if(today.isAfter(invoice_day)) {
                this.change_status_items = null;
            }

        },

        confirmChangeStatus(value) {
            if(value !== 'booked') {
                this.reservation.status = value;
                this.dialog_change_status = false;
                this.dialog_reservation_status = true;
            }
        },

        revertStatus() {
            this.dialog_reservation_status = false;
            this.comment = null;
            this.reservation.status = "booked";
        },

        changeStatus() {
            this.status_loading = true;

            let route = "";
            if(this.reservation.status === "canceled") {
                route = "/cancel";
            }
            if(this.reservation.status === "no-show") {
                route = "/no-show";
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/reservations/" + this.reservation.id + route;
            let endpoint_comment = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/comments/comments';

            let item_comment = {
                resource_owner: "services-bookings",
                resource_type: "booking",
                resource_id: this.reservation_id,
                body: this.comment
            }

            this.$axios.post(endpoint_comment, item_comment) // eslint-disable-next-line
                .then(() => {
                    this.$emit('Comment created.');
                })
                .catch(error => {
                    console.log(error);
                    this.$emit('Oops, something went wrong!');
                })

            this.$axios.delete(endpoint)
                .then(() => {
                    this.$emit("success", "Status changed.");
                })
                .catch(error => {
                    console.log(error);
                    this.$emit("error", "Oops, something went wrong");
                })
                .finally(() => {
                    this.$refs.reservation.getItem();
                    this.getItems();
                    this.status_loading = false;
                    this.dialog_reservation_status = false;
                });
        },

        sendEmail(reservation_id, param) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/reservations/" + reservation_id + "/resend";

            let payload = null;
            if(param === "send_to_hotel") {
                payload = {
                    send_to_hotel: 1
                };
            }
            if(param === "send_to_client") {
                payload = {
                    send_to_client: 1
                };
            }

            this.$axios.put(endpoint, payload)
                .then(() => {
                    this.$emit("success", "Email sent.");
                })
                .catch(error => {
                    console.log(error);
                    this.$emit("error", "Oops, something went wrong");
                });
        },

        seeReservation(current_reservation) {
            this.reservation = {};
            this.reservation_id = current_reservation.id;
            this.reservation = current_reservation;
            this.getNewStatusItems(current_reservation.check_in, current_reservation.check_out, current_reservation.status);
            this.comments = 0;
            this.show_comments = false;
            this.dialog_reservation = true;
        },

        printReservation(divPrint) {
            let elem = document.getElementById(divPrint);
            let domClone = elem.cloneNode(true);
            let printSection = document.getElementById("printSection");

            if(!printSection) {
                printSection = document.createElement("div");
                printSection.id = "printSection";
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
                document.body.appendChild(printSection);
            } else {
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
            }

            window.print();
        },

        getDownloadRervations() {
            this.download_loading_reservation = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            } else {
                orders = ['timestamp']
                dirs = ['desc']
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/reservations";

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    size: 10000,
                    page: 1,
                    order: orders,
                    dir: dirs,
                    stamp: stamp,
                    // operational fields
                    status: this.status,
                    timestamp_after: this.timestamp_after,
                    timestamp_before: this.timestamp_before,
                    check_in_after: this.check_in_after,
                    check_in_before: this.check_in_before,
                    check_out_after: this.check_out_after,
                    check_out_before: this.check_out_before
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    let items = response.data.data;
                    items.forEach(function (element, index) {
                        if(element.status === "booked") {
                            items[index].status = "Rezervat";
                        }
                        if(element.status === "no-show") {
                            items[index].status = "Neprezentat";
                        }
                        if(element.status === "canceled") {
                            items[index].status = "Anulat";
                        }
                        if(element.client_contact.phone === null) {
                            items[index].client_contact.phone = "";
                        }
                        if(element.hotel_contact.contact_email === null) {
                            items[index].hotel_contact.contact_email = "";
                        }
                        if(element.is_agency === false) {
                            items[index].agency.name = "";
                            let commission = {
                                'commissioning': {
                                    'agency': {
                                        'commission_percentage': "",
                                        'commission_value': ""
                                    }
                                }
                            };
                            items[index].agency = commission;
                        }
                        if(element.agency.commissioning === null) {
                            let commission = {
                                'commissioning': {
                                    'agency': {
                                        'commission_percentage': "",
                                        'commission_value': ""
                                    }
                                }
                            };
                            items[index].agency = commission;
                        }
                        if(element.agency === null) {
                            items[index].agency.name = "";
                        }
                        if(element.agency.name === null || element.agency.name === undefined) {
                            items[index].agency.name = "";
                        }

                        items[index].timestamp = this.$moment(element.timestamp * 1000)
                            .format('DD-MM-YYYY');
                        items[index].check_in = this.$moment(element.check_in * 1000)
                            .format('DD-MM-YYYY');
                        items[index].check_out = this.$moment(element.check_out * 1000)
                            .format('DD-MM-YYYY');

                        items[index].pricing.total = Number(element.pricing.total).toFixed(2);
                        items[index].pricing.after_tax = Number(element.pricing.after_tax).toFixed(2);
                        items[index].pricing.total_eur = Number(element.pricing.total_eur).toFixed(2);

                    }.bind(this));
                    this.$refs.csv_reservation.generate(items);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.download_loading_reservation = false;
                });
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format('D MMM YY');
        },

        numberComments(value) {
            this.comments = value;
        },


    }
};
</script>

<style>
.modal-reservation .v-speed-dial {
    position: absolute;
}

.modal-reservation .v-btn--floating {
    position: relative;
}

@media (max-width: 600px) {
    .v-dialog--fullscreen>.v-card.modal-reservation {
        padding-bottom: 50px !important;
    }

}

@media screen {
    #printSection {
        display: none;
    }
}

@media print {
    @page {
        size: A4;
    }

    body * {
        line-height: 1 !important;
        visibility: hidden;
    }

    #printSection,
    #printSection * {
        visibility: visible;
    }

    #printSection {
        min-height: auto;
        position: absolute;
        left: 0;
        top: 0;
        width: auto;
        page-break-after: avoid;
        page-break-inside: avoid;
    }

    #printSection .nowrap {
        flex-wrap: nowrap;
    }

    #printSection .nodisplay {
        display: none;
    }

    #printSection .reservation-modal .description {
        max-height: 100% !important;
        height: 100%;
    }

}
</style>
